import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import { getStoreBuilder } from 'vuex-typex';

// Each module must be explicitly imported here
// so that they are built before the store is built.
import './markersstate';
import { MarkersState } from './markersstate';
import './producttabstate';
import { ProductTabState } from './producttabstate';
import './meetingcalendarstate';
import { MeetingCalendarState } from './meetingcalendarstate';
import './checkoutstate';
import { CheckoutState } from './checkoutstate';
import './searchstate';
import { SearchState } from './searchstate';

export interface RootState {
    markers: MarkersState;
    products: ProductTabState;
    meetingCalendarState: MeetingCalendarState;
    checkout: CheckoutState;
    search: SearchState;
}

Vue.use(Vuex);

const store: Store<RootState> = getStoreBuilder<RootState>().vuexStore();
export default store;
